export default __webpack_public_path__ + "static/media/bg-2.0e35b5cd.jpg";